export * from '@wix/web-bi-logger/dist/src/types';
export * from '@wix/web-bi-logger/dist/src/logger';
export { default } from '@wix/web-bi-logger/dist/src/logger';
//# sourceMappingURL=index.js.map